/** Canonical URL prefix for SGRC Definitions (reference data) routes. */
export const DEFINITIONS_BASE_PATH = '/definitions';
